import classNames from 'classnames'
import { useCallback } from 'react'
import Badge from './Badge'
import styles from './BadgeWrapper.module.scss'
import type { BadgeProps } from '.'
import { BadgeSize, BadgeStyle } from '.'

const BadgeWrapper: React.FC<BadgeProps> = ({
  className,
  style = BadgeStyle.neutral,
  size = BadgeSize.medium,
  surfaceColor,
  value,
  onClick,
  children,
}: BadgeProps) => {
  const handleClick = useCallback(() => {
    onClick && onClick()
  }, [onClick])

  return (
    <div className={classNames(styles['pintxo-badge-wrapper'], className)} onClick={handleClick}>
      <Badge
        className={styles['pintxo-badge-wrapper__badge']}
        style={style}
        size={size}
        value={value}
        surfaceColor={surfaceColor}
      />
      {children}
    </div>
  )
}
export default BadgeWrapper
